import { render, staticRenderFns } from "./SchoolSplitClassesView.vue?vue&type=template&id=bcdc042a&scoped=true&"
import script from "./SchoolSplitClassesView.vue?vue&type=script&lang=js&"
export * from "./SchoolSplitClassesView.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSplitClassesView.vue?vue&type=style&index=0&id=bcdc042a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdc042a",
  null
  
)

export default component.exports